export const changeMgmtRouteEntries = {
  changeForm: () => import('./presentation/changes/form/ChangeFormPage'),
  changeDetail: () => import('./presentation/changes/detail/ChangeDetailPage'),
  executionTracker: () => import('./presentation/executionTracker/ExecutionTrackerPage'),
  templatesList: () => import('./presentation/templates/TemplatesListPage'),
  templateForm: () => import('./presentation/templates/TemplateFormPage'),
  templateDetail: () => import('./presentation/templates/TemplateDetailPage'),
  batchesList: () => import('./presentation/batches/BatchesListPage'),
  batchCreate: () => import('./presentation/batches/BatchCreatePage'),
  batchDetail: () => import('./presentation/batches/BatchDetailPage'),
} as const;